(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[27574],{

/***/ 22165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DebtReliefSavior; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/clearyourdebtsfast/debtReliefSavior/style.module.scss
var style_module = __webpack_require__(64799);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/components/clearyourdebtsfast/sharedButton/index.tsx
var sharedButton = __webpack_require__(47673);
;// CONCATENATED MODULE: ./src/components/clearyourdebtsfast/debtReliefSavior/icons/DebtReductionIcon.tsx


function DebtReductionIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "126",
        height: "126",
        fill: "none",
        viewBox: "0 0 126 126",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "63",
                cy: "63",
                r: "63",
                fill: "#B3CFD6",
                fillOpacity: "0.3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#000",
                d: "M51.628 69.382v15.91h8.208v-22.59h-8.208v6.68zM51.273 86h-8.918a.356.356 0 01-.355-.354V53.118c0-.195.16-.354.355-.354h8.918c.195 0 .355.16.355.354v8.876h8.563c.195 0 .355.16.355.355v23.297c0 .195-.16.354-.355.354h-8.918zm-.355-.709V53.472H42.71v31.82h8.207zM45.127 43.95l2.265-2.817a.348.348 0 01.506-.044l27.41 21.322 1.289-1.604a.358.358 0 01.604.08l4.68 9.115a.346.346 0 01-.4.496l-9.965-2.569a.35.35 0 01-.187-.558l1.28-1.594-27.42-21.331a.345.345 0 01-.062-.496zm2.602-2.1l-1.82 2.26L73.327 65.43a.352.352 0 01.053.496l-1.163 1.444 8.669 2.241-4.086-7.946-1.164 1.444a.364.364 0 01-.497.062L47.73 41.85zm22.979 29.862H62.5v13.58h8.208v-13.58zm-8.554-.709h8.918c.195 0 .355.16.355.354v14.289c0 .195-.16.354-.355.354h-8.918a.356.356 0 01-.355-.354V71.357a.35.35 0 01.355-.354zm20.278 11.755h-8.207v2.533h8.207v-2.533zm-8.562-.709h8.918c.195 0 .355.16.355.355v3.242c0 .195-.16.354-.355.354H73.87a.356.356 0 01-.356-.354v-3.242c0-.195.16-.355.356-.355z"
            })
        ]
    });
}
/* harmony default export */ var icons_DebtReductionIcon = (DebtReductionIcon);

;// CONCATENATED MODULE: ./src/components/clearyourdebtsfast/debtReliefSavior/icons/SinglePaymentIcon.tsx


function SinglePaymentIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "126",
        height: "126",
        fill: "none",
        viewBox: "0 0 126 126",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "63",
                cy: "63",
                r: "63",
                fill: "#B3CFD6",
                fillOpacity: "0.3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#000",
                d: "M69.173 50.803l-.006-.002s-.002 0-.002-.002c-.04-.016-.078-.018-.118-.022-.016-.002-.029-.01-.045-.01H57.513c-.01 0-.018.005-.027.005a.445.445 0 00-.136.027l-.003.002-.006.002C49.3 54.08 43 64.028 43 73.46 43 84.548 45.794 88 63.259 88c17.464 0 20.258-3.453 20.258-14.54 0-9.431-6.3-19.38-14.344-22.656zM63.26 87.138c-16.982 0-19.397-2.915-19.397-13.678 0-9.081 6.033-18.651 13.746-21.83h1.971l-1.573 3.673a.432.432 0 00.227.567c.217.09.47-.008.566-.227l1.72-4.014h5.48l1.718 4.014a.434.434 0 00.567.227.432.432 0 00.226-.566l-1.573-3.675h1.972c7.713 3.18 13.746 12.75 13.746 21.83 0 10.764-2.415 13.679-19.396 13.679z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#000",
                d: "M45.634 71.363a.43.43 0 00.478-.377c.116-.97.305-1.961.566-2.945a.431.431 0 00-.832-.22 22.246 22.246 0 00-.59 3.064c-.028.236.14.45.378.478zM51.5 84.177c-4.669-1.57-5.523-4.922-5.523-10.956a.431.431 0 00-.862 0c0 6.302.974 10.044 6.11 11.772a.432.432 0 00.546-.272.43.43 0 00-.271-.544zM69.003 48.44H57.515a.431.431 0 000 .862h11.488a.431.431 0 000-.862zM57.118 46.714c.001.002.004.002.005.005.029.066.079.12.136.162a.427.427 0 00.256.093h11.488a.427.427 0 00.256-.093.42.42 0 00.136-.162c0-.003.003-.004.004-.005l3.475-8.113a.434.434 0 00-.037-.408.429.429 0 00-.36-.193H54.04a.434.434 0 00-.397.602l3.475 8.112zm14.707-7.852l-3.107 7.25h-1.78l1.573-3.672a.432.432 0 00-.793-.34L66 46.113h-5.48L58.8 42.1a.432.432 0 00-.793.34l1.573 3.673H57.8l-3.108-7.25h17.133zM66.316 66.028c0 .88.712 1.595 1.59 1.595.876 0 1.589-.715 1.589-1.595 0-2.849-1.933-5.343-4.646-6.062v-.41c0-.88-.713-1.596-1.59-1.596-.876 0-1.59.716-1.59 1.596v.41c-2.712.72-4.647 3.214-4.647 6.062 0 2.845 1.934 5.337 4.648 6.055v5.897a3.081 3.081 0 01-1.468-2.616c0-.88-.713-1.595-1.59-1.595-.877 0-1.59.716-1.59 1.595 0 2.85 1.934 5.346 4.648 6.064v.406c0 .879.713 1.595 1.59 1.595.876 0 1.59-.716 1.59-1.595v-.406c2.711-.72 4.645-3.214 4.645-6.064 0-2.847-1.934-5.338-4.646-6.056v-5.894a3.078 3.078 0 011.466 2.614zm-1.984 4.044c2.492.508 4.3 2.734 4.3 5.292 0 2.562-1.809 4.791-4.3 5.299l-.345.07v1.1a.731.731 0 01-.727.733.731.731 0 01-.728-.733v-1.1l-.345-.07c-2.493-.509-4.302-2.738-4.302-5.3 0-.403.327-.732.728-.732.4 0 .727.329.727.733a3.946 3.946 0 002.617 3.704l.576.206V71.39l-.345-.07c-2.493-.51-4.302-2.735-4.302-5.292 0-2.56 1.81-4.788 4.303-5.298l.344-.07v-1.104c0-.404.326-.733.727-.733.401 0 .728.329.728.733v1.104l.344.07c2.493.51 4.3 2.738 4.3 5.298a.732.732 0 01-.727.733c-.4 0-.727-.329-.727-.733a3.943 3.943 0 00-2.615-3.702l-.576-.206v7.882l.345.07z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#000",
                d: "M59.34 66.028a3.939 3.939 0 002.616 3.695l.576.206v-7.81l-.576.205a3.947 3.947 0 00-2.616 3.704zm2.33 2.607a3.07 3.07 0 01-1.468-2.607c0-1.076.57-2.063 1.468-2.614v5.221zM63.987 79.274l.577-.206a3.947 3.947 0 002.614-3.704 3.94 3.94 0 00-2.615-3.698l-.576-.206v7.814zm.862-6.52a3.073 3.073 0 011.466 2.609 3.08 3.08 0 01-1.466 2.615v-5.225z"
            })
        ]
    });
}
/* harmony default export */ var icons_SinglePaymentIcon = (SinglePaymentIcon);

;// CONCATENATED MODULE: ./src/components/clearyourdebtsfast/debtReliefSavior/icons/FinancialEmpowermentIcon.tsx


function FinancialEmpowermentIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "126",
        height: "126",
        fill: "none",
        viewBox: "0 0 126 126",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "63",
                cy: "63",
                r: "63",
                fill: "#B3CFD6",
                fillOpacity: "0.3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#000",
                d: "M62.96 68.913a.615.615 0 00-.836.215.615.615 0 00.216.836c.875.516 1.861 1.652 2.52 2.906.778 1.482 1.058 2.997.784 4.27a.61.61 0 00.464.725c.045.007.085.014.13.014.281 0 .536-.196.595-.484.333-1.547.02-3.356-.895-5.093-.764-1.456-1.907-2.756-2.978-3.383v-.006z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#000",
                d: "M80.48 59.066a3.574 3.574 0 00-1.71-2.11 3.58 3.58 0 00-3.043-.196c-.092.033-.177.072-.262.112a3.58 3.58 0 00-.444-1.914 3.644 3.644 0 00-2.344-1.795 3.604 3.604 0 00-2.73.418c-.215.13-.41.28-.594.444a4.299 4.299 0 00-3.54-3.213 4.161 4.161 0 00-3.153.803 4.31 4.31 0 00-.927.96 4.4 4.4 0 00-.549-.92 4.715 4.715 0 00-3.128-1.842 4.7 4.7 0 00-3.434.862 4.721 4.721 0 00-1.874 3.003l-.138.758a3.689 3.689 0 00-3.52 2.233l-3.806 8.927a5.811 5.811 0 00.81 5.916l7.75 9.684c.392.49.608 1.103.608 1.73v4.467a.606.606 0 101.215 0v-4.467c0-.901-.314-1.79-.876-2.494l-7.75-9.684a4.602 4.602 0 01-.64-4.682l3.806-8.927a2.47 2.47 0 013.083-1.358l7.594 2.658.842.294c.203.071.327.28.3.49a5.27 5.27 0 01-4.969 4.505c-.607.026-1.136.026-1.606 0h-.046c-1.737-.085-2.566-.464-2.964-.81a.61.61 0 10-.797.928c.633.542 1.613.888 2.932 1.038-.333.796-.914 1.645-1.776 2.148a.613.613 0 00-.216.836.605.605 0 00.836.216c1.463-.856 2.148-2.293 2.43-3.115.398.006.816 0 1.26-.013a6.375 6.375 0 002.958-.869 3.938 3.938 0 006.517 1.143 3.312 3.312 0 003.062 2.005c.542 0 1.078-.131 1.56-.392.36-.19.673-.438.935-.738a3.169 3.169 0 001.56 1.567 3.2 3.2 0 004.192-1.43l1.515-2.919c0 3.337-.326 6.687-.973 9.965l-.835 4.244a9.618 9.618 0 01-2.325 4.617l-1.456 1.6a.6.6 0 00-.157.411v3.233a.606.606 0 101.215 0v-2.998l1.3-1.423a10.786 10.786 0 002.618-5.204l.835-4.245c.66-3.35.993-6.785.993-10.2v-3.18a3.63 3.63 0 00-.157-1.084l.013.007zM55.34 51.66a3.519 3.519 0 014.878.724c.568.751.803 1.679.672 2.613l-.293 2.056-6.792-2.37.138-.79a3.506 3.506 0 011.39-2.233h.007zm9.925 13.118a2.699 2.699 0 01-1.834.484 2.724 2.724 0 01-2.332-1.914 6.513 6.513 0 002.142-3.937 1.663 1.663 0 00-1.103-1.816l-.366-.124.418-2.755v-.013c.11-.856.535-1.607 1.208-2.11a2.976 2.976 0 012.24-.568c.868.13 1.62.601 2.109 1.332.49.732.64 1.607.43 2.456l-1.834 7.398a2.718 2.718 0 01-1.07 1.567h-.007zm3.834 1.17a2.129 2.129 0 01-1.509-2.58l1.88-7.268a2.404 2.404 0 011.098-1.47 2.463 2.463 0 011.822-.28 2.409 2.409 0 011.56 1.195c.333.607.392 1.306.164 1.959l-2.469 7.092a2.127 2.127 0 01-2.546 1.351zm7.718-.255a1.977 1.977 0 01-2.599.881 1.985 1.985 0 01-1.045-2.43l1.6-4.785a2.358 2.358 0 011.391-1.463c.28-.111.575-.163.868-.163.399 0 .79.097 1.143.293.549.3.954.797 1.136 1.398.183.6.125 1.234-.163 1.789l-2.331 4.48zM62.732 43.883c.34 0 .607-.274.607-.607v-4.669a.606.606 0 10-1.214 0v4.67c0 .339.274.606.607.606zM39.276 71.78h-4.669a.606.606 0 100 1.214h4.67a.606.606 0 100-1.215zM49.32 48.095c.117.164.3.248.49.248.123 0 .254-.039.358-.117a.606.606 0 00.124-.849L47.51 43.63a.606.606 0 10-.972.725l2.781 3.748v-.007zM41.555 58.373l-4.414-1.527a.61.61 0 00-.777.378.61.61 0 00.379.777l4.414 1.528c.065.02.13.033.202.033a.61.61 0 00.196-1.188zM90.856 71.78h-4.668a.606.606 0 100 1.214h4.668a.606.606 0 100-1.215zM75.384 48.262a.62.62 0 00.359.117c.19 0 .372-.084.49-.248l2.781-3.748a.605.605 0 00-.124-.849.605.605 0 00-.849.124l-2.781 3.748a.605.605 0 00.124.85v.006zM89.093 57.224a.615.615 0 00-.777-.378l-4.414 1.528a.615.615 0 00-.379.777c.085.254.32.411.575.411.065 0 .13-.013.202-.033l4.415-1.528a.615.615 0 00.378-.777z"
            })
        ]
    });
}
/* harmony default export */ var icons_FinancialEmpowermentIcon = (FinancialEmpowermentIcon);

;// CONCATENATED MODULE: ./src/components/clearyourdebtsfast/debtReliefSavior/icons/LegalGuidanceIcon.tsx


function LegalGuidanceIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "126",
        height: "126",
        fill: "none",
        viewBox: "0 0 126 126",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "63",
                cy: "63",
                r: "63",
                fill: "#B3CFD6",
                fillOpacity: "0.3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#000",
                d: "M63 38c-13.8 0-25 11.2-25 25s11.2 25 25 25 25-11.2 25-25-11.2-25-25-25zm-.641 1.302v1.042a.643.643 0 00.888.6.64.64 0 00.394-.6v-1.042c6.064.161 11.54 2.605 15.645 6.49l-.721.722a.645.645 0 00.901.921l.742-.741a23.595 23.595 0 016.49 15.665h-1.042a.632.632 0 00-.38.076.643.643 0 00-.094 1.068.645.645 0 00.474.138h1.042a23.661 23.661 0 01-6.47 15.685l-.762-.761a.64.64 0 00-.52-.2.641.641 0 00-.381 1.101l.741.742a23.58 23.58 0 01-15.665 6.49v-1.062a.641.641 0 10-1.282 0v1.062a23.58 23.58 0 01-15.665-6.49l.741-.742a.64.64 0 00-.52-1.101.64.64 0 00-.381.2l-.762.761a23.661 23.661 0 01-6.47-15.685h1.042a.643.643 0 00.6-.888.64.64 0 00-.6-.394h-1.042a23.595 23.595 0 016.49-15.665l.742.741a.645.645 0 10.901-.921l-.721-.722c4.105-3.885 9.581-6.329 15.645-6.49zm.56 4.968a.64.64 0 00-.54.46L59.074 56.05a.647.647 0 101.242.36L63 47.215l2.684 9.194a.649.649 0 00.802.441.647.647 0 00.44-.801L63.621 44.73a.641.641 0 00-.701-.461zm-6.65 14.764a.641.641 0 00-.16.02.651.651 0 00-.04.02L44.73 62.379a.641.641 0 000 1.222l11.338 3.305a.642.642 0 10.36-1.222L47.195 63l9.234-2.704a.642.642 0 00-.16-1.262zm13.362.02a.641.641 0 00-.06 1.242L78.804 63l-9.235 2.684a.64.64 0 10.361 1.222l11.338-3.305a.642.642 0 000-1.222l-11.338-3.305a.641.641 0 00-.3-.02zM63 60.516A2.494 2.494 0 0060.516 63 2.494 2.494 0 0063 65.484 2.494 2.494 0 0065.484 63 2.494 2.494 0 0063 60.516zm0 1.282c.671 0 1.202.53 1.202 1.202 0 .671-.53 1.202-1.202 1.202-.671 0-1.202-.53-1.202-1.202 0-.671.53-1.202 1.202-1.202zm-3.425 7.312a.641.641 0 00-.501.821l3.305 11.318a.641.641 0 001.242 0l3.305-11.318a.647.647 0 10-1.242-.36L63 78.764l-2.684-9.195a.64.64 0 00-.742-.46z"
            })
        ]
    });
}
/* harmony default export */ var icons_LegalGuidanceIcon = (LegalGuidanceIcon);

;// CONCATENATED MODULE: ./src/components/clearyourdebtsfast/debtReliefSavior/index.tsx








const pointsList = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_DebtReductionIcon, {}),
        title: "debt reduction",
        description: "Debt relief programs specialize in negotiating with creditors to slash the total amount you owe, making your debts more manageable"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_SinglePaymentIcon, {}),
        title: "single payment",
        description: "Simplify your financial life by consolidating your debts into a single, stress-free payment."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_FinancialEmpowermentIcon, {}),
        title: "financial empowerment",
        description: "Gain invaluable knowledge through expert credit counseling, enabling you to make informed financial decisions."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_LegalGuidanceIcon, {}),
        title: "legal guidance",
        description: "Navigate complex bankruptcy proceedings, if required, with the assistance of seasoned professionals."
    }, 
];
function DebtReliefSavior() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (style_module_default()).mainContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "font-bold lg:text-3xl text-2xl lg:leading-10 text-[#71ABBE] text-center sm:text-center mt-[50px] mb-[30px] sm:mb-[50px]",
                    children: "How Debt Relief Can Be Your Savior:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `${(style_module_default()).cardsContainer}`,
                    children: pointsList.map((point, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: `flex flex-col items-center p-6 py-8 rounded-[25px] bg-white gap-4 ${(style_module_default()).cardContainer}`,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: point.icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-lg font-extrabold capitalize",
                                    children: point.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "lg:text-base lg:leading-8 text-center",
                                    children: point.description
                                })
                            ]
                        }, index))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "my-10 text-center sm:text-left",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sharedButton/* default */.Z, {})
                })
            ]
        })
    });
}


/***/ }),

/***/ 1858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



const FinancialFreedom = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "flex items-center justify-center mt-[150px] sm:mt-[200px]",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col-reverse sm:flex-row items-center gap-6 justify-around w-full sm:w-[1200px] rounded-[45px] bg-[#D5E9F0] sm:p-20 p-7",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col items-start gap-10 sm:max-w-[45%] h-full",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-xl sm:text-2xl font-bold",
                            children: "Your Journey to Financial Freedom Begins Here"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-base leading-[29px] font-[18px]",
                            children: "Initiating your pursuit of financial freedom is a breeze. Just complete our brief and straightforward form. Doing so lets you connect with a reputable debt relief agency for your cost-free financial consultation. It's a no-risk opportunity to explore your options, uncover possibilities, and break free from the shackles of debt."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-[251px] h-[253px] md:w-[355px] md:h-[340px] relative",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/clearyourdebtsfast/assets/images/financialFreedom.png",
                        alt: "Image",
                        layout: "fill"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FinancialFreedom);


/***/ }),

/***/ 67764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MainBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_shared_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96119);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72497);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);
/* harmony import */ var _components_shared_textBlockOffer_TextBlockOffer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45464);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_7__);









function MainBanner() {
    const { visitDetails , domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const isFormDisplayed = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .finalShowForm */ .r6)(router.query.sl, domain.showForm, domain.defaultOffers);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isFormDisplayed ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["main-banner"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_form__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    classes: {
                        formClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().form),
                        stepTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["step-title"]),
                        stepDescriptionClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["step-description"]),
                        formButtonClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["form-button"]),
                        formFieldClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["form-field"]),
                        formStepInnerClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["steps-inner"]),
                        stepClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().step),
                        fieldsClassName: {
                            radio: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["radio-field"]),
                            checkbox: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["checkbox-field"]),
                            all: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().field),
                            input: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["input-field"])
                        },
                        fieldsWrapperClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["fields-wrapper"]),
                        tcpaClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().tcpa),
                        labelAsTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["label-as-step-title"]),
                        fieldNoteClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["field-note"]),
                        fieldErrorMessageClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["field-error-message"]),
                        sellingPointClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["selling-point"]),
                        formProgressbarClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["progress-background"])
                    },
                    colors: {
                        primaryColor: "#71abbe",
                        progressBar: "#B3B3B3"
                    },
                    showProgress: true,
                    goToThankYouPage: false,
                    sellingPoint: visitDetails?.region ? `${visitDetails?.region}'s Best Debt Relief Companies` : "",
                    sellingPointsSteps: "FIRST_STEP",
                    dynamicThankYouFields: [
                        "firstName"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "lg:w-[450px] lg:h-[500px] lg:block relative top-[60px] hidden z-10",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                        src: "/clearyourdebtsfast/assets/images/woman.png",
                        alt: "Image",
                        layout: "fill"
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_textBlockOffer_TextBlockOffer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
    });
}


/***/ }),

/***/ 47673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SharedButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90647);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function SharedButton() {
    const scrollToTop = ()=>{
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: ()=>scrollToTop(),
        className: `bg-[#E0A293]  py-4 sm:px-16 px-4 text-[13px] font-bold sm:text-lg  rounded-[13px] ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_1___default().animation)} `,
        children: "Claim Your Complimentary Financial Consultation"
    });
}


/***/ }),

/***/ 39836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StreamlinedTheProcess; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sharedButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47673);




function StreamlinedTheProcess() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "flex flex-col lg:flex-row lg:gap-40 gap-8 lg:mt-[250px] mt-24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-[620px] mx-auto lg:mx-0 order-2 lg:order-1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "font-bold lg:text-3xl text-2xl lg:leading-[45px] text-[#71ABBE] ",
                        children: "We've streamlined the debt relief process for your convenience:"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "mt-7 font-light lg:text-lg text-base lg:leading-8 ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-bold",
                                children: "Assessment:"
                            }),
                            " It all starts with a comprehensive financial assessment. We meticulously examine your debts, income, and financial objectives."
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "mt-4 font-light lg:text-lg text-base lg:leading-8 ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-bold",
                                children: "Tailored Plan:"
                            }),
                            " Based on the assessment, we craft a customized debt relief plan designed exclusively for your unique circumstances. This plan may include debt settlement negotiations, debt consolidation, credit counseling, or bankruptcy guidance."
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "mt-4 font-light lg:text-lg text-base lg:leading-8 ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-bold",
                                children: "Direct Communication:"
                            }),
                            " We take the reins in communicating with your creditors to secure advantageous terms on your behalf, such as reduced balances or interest rates."
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "mt-4 font-light lg:text-lg text-base lg:leading-8 ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-bold",
                                children: "Dedicated Account:"
                            }),
                            " You'll make regular contributions to a dedicated account, which will be used to fund settlements or consolidated payments as your debt relief journey unfolds."
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "mt-4 font-light lg:text-lg text-base lg:leading-8 ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-bold",
                                children: "Progress and Freedom:"
                            }),
                            " As the process advances, you'll witness your debt shrink, bringing you profound financial relief. In many cases, this path leads to becoming debt-free."
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "sm:mt-12 mt-8 text-center sm:text-left",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sharedButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-[221px] h-[253px] md:w-[405px] md:min-w-[305px] md:h-[600px] sm:min-h-[300px] relative mx-auto lg:mx-0 order-1 lg:order-2 lg:mt-12 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: "/clearyourdebtsfast/assets/images/streamlinedTheProcess.png",
                    alt: "Image",
                    layout: "fill"
                })
            })
        ]
    });
}


/***/ }),

/***/ 40296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sharedButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47673);




const TakeTheReins = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "flex items-center justify-center mt-[150px] lg:mt-[250px] mb-40",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col-reverse sm:flex-row-reverse items-center gap-6 justify-between rounded-[45px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col items-start gap-10 sm:max-w-[60%] h-full",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-xl sm:text-2xl font-bold",
                            children: "Are You Ready to Take the Reins of Your Finances?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-base leading-[29px] font-[18px]",
                            children: "Don't let debt hold you hostage any longer. Your voyage towards financial freedom commences today. Fill out the form on this page, and we'll connect you with a trusted debt relief specialist who will accompany you every step of the way. Your brighter financial future is within reach."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "self-center sm:self-start",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sharedButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-[251px] h-[253px] md:w-[280px] md:h-[280px] relative",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/clearyourdebtsfast/assets/images/takeTheReins.png",
                        alt: "Image",
                        layout: "fill"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TakeTheReins);


/***/ }),

/***/ 82742:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__eQ4WB"};

/***/ }),

/***/ 64799:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animation":"style_animation__ALEkt","mainContainer":"style_mainContainer___1CKJ","cardsContainer":"style_cardsContainer__gSaxQ","cardContainer":"style_cardContainer__cD_LP"};

/***/ }),

/***/ 72497:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","selling-point":"styles_selling-point__Ze8k_","main-banner":"styles_main-banner__xSu37","form":"styles_form__m3008","step":"styles_step__12cdC","form-field":"styles_form-field___5b5q","step-title":"styles_step-title__hLFbl","steps-inner":"styles_steps-inner__q0kaI","label-as-step-title":"styles_label-as-step-title__FBrKU","step-description":"styles_step-description__MW5lS","fields-wrapper":"styles_fields-wrapper__PGQGM","form-button":"styles_form-button__gH__c","radio-field":"styles_radio-field__FGUDA","checkbox-field":"styles_checkbox-field__Fs4D4","field-note":"styles_field-note__BO0U_","input-field":"styles_input-field__xGNv5","field-error-message":"styles_field-error-message__K5Nqn","field":"styles_field__WzllV","tcpa":"styles_tcpa__UvmwX","image":"styles_image__VZx4s"};

/***/ }),

/***/ 90647:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animation":"style_animation__Ywy6H"};

/***/ })

}]);